import api from '../api/axios';

const getLogs = (params = {}) => {
  const queryParams = new URLSearchParams();
  
  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.action) queryParams.append('action', params.action);
  if (params.email) queryParams.append('email', params.email);
  if (params.ipAddress) queryParams.append('ipAddress', params.ipAddress);
  if (params.startDate) queryParams.append('startDate', params.startDate);
  if (params.endDate) queryParams.append('endDate', params.endDate);
  
  return api.get(`/auth-logs?${queryParams.toString()}`);
};

const getStats = () => {
  return api.get('/auth-logs/stats');
};

const getBlockedIps = (includeExpired = false) => {
  return api.get(`/auth-logs/blocked-ips?includeExpired=${includeExpired}`);
};

const unblockIp = (id) => {
  return api.delete(`/auth-logs/blocked-ips/${id}`);
};

const permanentBlockIp = (id) => {
  return api.delete(`/auth-logs/blocked-ips/${id}/permanent`);
};

const logout = () => {
  return api.post('/auth/logout');
};

export const authLogServices = {
  getLogs,
  getStats,
  getBlockedIps,
  unblockIp,
  permanentBlockIp,
  logout
};

